import React from 'react'

const EVStation = (props) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48' {...props}>
      <title>EV Station</title>
      <path
        d='M16.85 37.3 21.25 30.3H18.6V25.05L14.25 32.05H16.85ZM11 20.4H24.45V9Q24.45 9 24.45 9Q24.45 9 24.45 9H11Q11 9 11 9Q11 9 11 9ZM11 39H24.45V23.4H11ZM8 42V9Q8 7.8 8.9 6.9Q9.8 6 11 6H24.45Q25.65 6 26.55 6.9Q27.45 7.8 27.45 9V23.4H30.7Q31.75 23.4 32.475 24.125Q33.2 24.85 33.2 25.9V36.85Q33.2 37.95 34.075 38.675Q34.95 39.4 36.1 39.4Q37.25 39.4 38.25 38.675Q39.25 37.95 39.25 36.85V17.5H38.5Q37.9 17.5 37.45 17.05Q37 16.6 37 16V11.5H38V9H39.5V11.5H41.5V9H43V11.5H44V16Q44 16.6 43.575 17.05Q43.15 17.5 42.5 17.5H41.75V36.85Q41.75 39 40.05 40.5Q38.35 42 36.1 42Q33.9 42 32.3 40.5Q30.7 39 30.7 36.85V25.9Q30.7 25.9 30.7 25.9Q30.7 25.9 30.7 25.9H27.45V42ZM24.45 39H11H24.45Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default React.memo(EVStation)
